import { type RefObject, createContext } from 'react';

export const ChannelWrapperContext = createContext<RefObject<HTMLDivElement | null>>({ current: null });
